import { CentreType, ModeratorInfo, SubmittedModeratedCentre } from '@cambridgeassessment/lib-ee-commons';
import { PostResultsParams } from '../../types/PostResults';
import * as actions from './actions';
import { PostResultsActionTypes } from './types';
import * as service from '../../service/postResults/index';
import { displayNotification } from '../notification/actions';
import { NotificationActionTypes } from '../notification/types';

type Dispatchable = PostResultsActionTypes | NotificationActionTypes | ((action: Dispatchable) => Promise<void>);
type Dispatch = (action: Dispatchable) => void | Promise<void>;

export const getCentreWithModerators =
  (queryParams: PostResultsParams) =>
  async (dispatch: Dispatch): Promise<void> => {
    try {
      dispatch(actions.setFetchingCentre(true));
      dispatch(actions.resetCentreState());
      dispatch(actions.resetConsortiumState());
      dispatch(actions.resetModeratorsState());
      dispatch(actions.resetAllocatedModeratorState());

      const centreOrConsortium: SubmittedModeratedCentre = await service.getSubmittedModeratedCentre(queryParams);

      if (centreOrConsortium.centreType === CentreType.CONSORTIA) {
        dispatch(actions.setConsortium(centreOrConsortium.centres, centreOrConsortium.consortiumName));
      } else {
        dispatch(actions.setCentre(centreOrConsortium.centres));
      }
      if (centreOrConsortium.moderator) {
        dispatch(actions.setAllocatedModerator(centreOrConsortium.moderator));
      }

      const moderators: ModeratorInfo[] = await service.getAvailableModerators(queryParams);
      dispatch(actions.setModerators(moderators));
      dispatch(actions.setFetchingCentre(false));
    } catch {
      dispatch(displayNotification('Failed to get centre or moderators'));
    }
  };

export const setPostResultsReviewModerator =
  (queryParams: PostResultsParams, moderator: ModeratorInfo) =>
  async (dispatch: Dispatch): Promise<void> => {
    try {
      await service.setPostResultsReviewModerator(queryParams, moderator.creditorNumber);

      dispatch(actions.setAllocatedModerator(moderator));
      dispatch(displayNotification('Changes were saved'));
    } catch {
      dispatch(displayNotification('Failed to save changes'));
    }
  };

export const unallocatePostResultsReviewModerator =
  (queryParams: PostResultsParams, creditorNumber: number) =>
  async (dispatch: Dispatch): Promise<void> => {
    try {
      await service.unallocatePostResultModerator(queryParams, creditorNumber);

      dispatch(actions.setAllocatedModerator(undefined));
      dispatch(displayNotification('Moderator successfully unallocated'));
    } catch {
      dispatch(displayNotification('Failed to unallocate moderator'));
    }
  };
